export type TOrganizationsListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: 'asc' | 'desc';
  search: string;
  includeExternallyManaged?: boolean;
};

export type TMembersListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: 'asc' | 'desc';
  search: string;
  teamsSlugFilter: string;
};

export type TMemberReportsListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: 'asc' | 'desc';
  search: string;
  jobsFrom: string;
  jobsTo: string;
};

export type TInvitationsListParams = {
  search: string;
};

export const organizationsKeys = {
  all: [{ module: 'organizations' }] as const,
  lists: () => [{ ...organizationsKeys.all[0], scope: 'list' }] as const,
  list: (params: TOrganizationsListParams) => [{ ...organizationsKeys.lists()[0], params }] as const,
  allList: () => [{ ...organizationsKeys.all[0], scope: 'allList' }] as const,
  details: () => [{ ...organizationsKeys.all[0], scope: 'detail' }] as const,
  detail: (organizationId: string) => [{ ...organizationsKeys.details()[0], organizationId }] as const,
  summaries: () => [{ ...organizationsKeys.all[0], scope: 'summary' }] as const,
  summary: (organizationId: string) => [{ ...organizationsKeys.summaries()[0], organizationId }] as const,
  invitations: () => [{ ...organizationsKeys.all[0], scope: 'invitations' }] as const,
  invitationsByOrg: (organizationId: string) => [{ ...organizationsKeys.invitations()[0], organizationId }] as const,
  invitationsList: (organizationId: string, params: TInvitationsListParams) =>
    [{ ...organizationsKeys.invitationsByOrg(organizationId)[0], params }] as const,
  members: () => [{ ...organizationsKeys.all[0], scope: 'members' }] as const,
  membersByOrg: (organizationId: string) => [{ ...organizationsKeys.members()[0], organizationId }] as const,
  membersList: (organizationId: string, params: TMembersListParams) =>
    [{ ...organizationsKeys.membersByOrg(organizationId)[0], params }] as const,
  memberReports: () => [{ ...organizationsKeys.all[0], scope: 'memberReports' }] as const,
  memberReportsByOrg: (organizationId: string) =>
    [{ ...organizationsKeys.memberReports()[0], organizationId }] as const,
  memberReportsList: (organizationId: string, params: TMemberReportsListParams) =>
    [{ ...organizationsKeys.memberReportsByOrg(organizationId)[0], params }] as const,
  memberDetails: () => [{ ...organizationsKeys.all[0], scope: 'memberDetail' }] as const,
  memberDetail: (organizationId: string, userId: string) =>
    [{ ...organizationsKeys.memberDetails()[0], organizationId, userId }] as const,
  workspaces: () => [{ ...organizationsKeys.all[0], scope: 'workspaces' }] as const,
  workspacesByOrg: (organizationId: string) => [{ ...organizationsKeys.workspaces()[0], organizationId }] as const,
  featureFlags: () => [{ ...organizationsKeys.all[0], scope: 'featureFlags' }] as const,
  featureFlagsByOrg: (organizationId: string, slug: string) =>
    [{ ...organizationsKeys.featureFlags()[0], organizationId, slug }] as const,
};
